import { render, staticRenderFns } from "./ChatSale.vue?vue&type=template&id=0f85d3a5&scoped=true&"
import script from "./ChatSale.vue?vue&type=script&lang=js&"
export * from "./ChatSale.vue?vue&type=script&lang=js&"
import style0 from "./ChatSale.vue?vue&type=style&index=0&id=0f85d3a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f85d3a5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFabTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VDialog,VFabTransition,VIcon,VProgressCircular,VTab,VTabItem,VTabs,VTabsItems})
